export const QUESTIONS = [
    'What would you tell someone who asked you about VirtualGlass™?',
    'What could we change/do to make VirtualGlass™ more user-friendly for participants?',
    'What have we not thought of in the design of VirtualGlass™?',
    'If you were a facilitator using VirtualGlass™, what features would you like included that were not showcased today?'
]
